import { PayBillLink } from '@app/router/constants';
import { useNavigate } from '@app/hooks';

import { ChangeBillDate } from './change-bill-date';

const SelectBillCycle = () => {
  const { replace } = useNavigate();

  const navigateToPreviousPage = () => replace(`/${PayBillLink.PayBill}`);

  return <ChangeBillDate navigateToPreviousPage={navigateToPreviousPage} />;
};

export default SelectBillCycle;
